import { RoundButtonsContainer } from "@/components/tools/RoundButtonsContainer";
import { RoundButtonWithIcon } from "@/components/tools/RoundButtonWithIcon";
import { Panel } from "@/components/ui/Panel";
import { cn } from "@/lib/utils";
import { InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import type { HTMLAttributes, ReactNode } from "react";

export function HintWindow({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("card-window", className)} {...props} />;
}

export function HintWindowHeader({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <Panel
      variant="shell"
      className={cn(
        "app-hint-window__header app-hint-window__panel-header",
        className,
      )}
      {...props}
    />
  );
}

export function HintWindowBody({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <Panel
      variant="shell"
      className={cn(
        "app-hint-window__inner app-hint-window__panel-body",
        className,
      )}
      {...props}
    />
  );
}

type HelpHintWindowProps = {
  eyebrow: string;
  title: string;
  description: ReactNode;
  closeLabel: string;
  onClose: () => void;
  children: ReactNode;
};

export function HelpHintWindow({
  eyebrow,
  title,
  description,
  closeLabel,
  onClose,
  children,
}: HelpHintWindowProps) {
  return (
    <HintWindow>
      <HintWindowHeader>
        <div className="app-hint-window__icon">
          <InformationCircleIcon className="size-5" />
        </div>
        <div className="app-hint-window__copy">
          <p className="app-hint-window__eyebrow">{eyebrow}</p>
          <p className="app-hint-window__title">{title}</p>
          <div className="app-hint-window__description">{description}</div>
        </div>
        <RoundButtonsContainer>
          <RoundButtonWithIcon
            icon={XMarkIcon}
            text={closeLabel}
            ariaLabel={closeLabel}
            onClick={onClose}
          />
        </RoundButtonsContainer>
      </HintWindowHeader>
      <HintWindowBody>{children}</HintWindowBody>
    </HintWindow>
  );
}
